import React from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from './IconButton';

export function IconEditLink(props: { to: string }) {
    const navigate = useNavigate();
    return <IconButton iconClass="fa-edit" onClick={() => navigate(props.to)} />;
}
